import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/tour-2024.jpg'


const _withScopeId = n => (_pushScopeId("data-v-23c4727e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tour" }
const _hoisted_2 = { class: "sizing" }
const _hoisted_3 = { class: "custom-layout" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"title\" data-v-23c4727e>HIRAIDAI TOUR 2024</div><div class=\"image-wrapper\" data-v-23c4727e><img src=\"" + _imports_0 + "\" alt=\"Top image\" data-v-23c4727e></div><div class=\"buttons\" data-v-23c4727e><a href=\"#tour-lists\" class=\"text-button\" data-v-23c4727e> &gt;&gt; TOUR SCHEDULE &lt;&lt; </a><a href=\"#coupons\" class=\"text-button\" data-v-23c4727e> &gt;&gt; LOCALS ONLY 来場者特典 &lt;&lt; </a></div><div class=\"title\" data-v-23c4727e>TOUR SCHEDULE</div>", 4)
const _hoisted_8 = {
  id: "tour-lists",
  class: "content-wrapper"
}
const _hoisted_9 = { class: "content-col" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "button-col" }
const _hoisted_12 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentItems, (row, rowIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              key: rowIndex,
              class: "row"
            }, [
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.visibleItems, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "content-row div-text"
                  }, [
                    _createElementVNode("div", {
                      style: _normalizeStyle({ fontSize: _ctx.getFontSize(index) })
                    }, [
                      _createElementVNode("p", { innerHTML: item }, null, 8, _hoisted_10)
                    ], 4)
                  ]))
                }), 128)),
                _createElementVNode("div", {
                  class: _normalizeClass(['hidden-content', { 'hidden-content-expanded': _ctx.expandedRows[rowIndex] }])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.hiddenItems, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: 'hidden-' + index,
                      class: "content-row"
                    }, _toDisplayString(item), 1))
                  }), 128))
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.toggleRow(rowIndex)),
                  class: "toggle-button"
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(_ctx.expandedRows[rowIndex] ? 'fas fa-chevron-down' : 'fas fa-chevron-right')
                  }, null, 2)
                ], 8, _hoisted_12)
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}